export default __webpack_public_path__ + "heroImage.png";